import type { CandidateNotification } from '@/features/candidate-notifications/types'
import { get, post } from '../client'

export async function listCandidateNotifications(): Promise<{
  notifications: CandidateNotification[]
}> {
  return get<{ notifications: CandidateNotification[] }>('api/candidate/notifications?limit=30')
}

export async function getUnreadCount(): Promise<{ unread: number }> {
  return get<{ unread: number }>('api/candidate/notifications/unread-count')
}

export async function markRead(id: number): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>(`api/candidate/notifications/${id}/read`, {})
}

export async function markAllRead(): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>('api/candidate/notifications/read-all', {})
}
